"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unsubscribe = exports.subscribe = exports.filterMessages = exports.matches = exports.typeMatches = void 0;
const config_1 = require("./services/config");
const typeMatches = (pattern) => (messageType) => {
    if (!pattern || !messageType)
        return false;
    if (pattern === '*' || messageType === pattern)
        return true;
    const patternParts = pattern.split(':');
    const typeParts = messageType.split(':');
    if (!typeParts[0] || patternParts[0] !== typeParts[0])
        return false;
    return (0, exports.typeMatches)(patternParts.slice(1).join(':'))(typeParts.slice(1).join(':'));
};
exports.typeMatches = typeMatches;
const matches = (pattern) => (message) => (0, exports.typeMatches)(pattern)(message.type);
exports.matches = matches;
const filterMessages = (messages, pattern) => messages.filter((0, exports.matches)(pattern));
exports.filterMessages = filterMessages;
const listeners = {};
const subscribe = (pattern, handler) => {
    const listenerId = `${pattern}_${Math.round(Math.random() * 1000000000000000)}`;
    const listener = ({ origin, data }) => {
        if (origin !== (0, config_1.getInterlocutor)())
            return;
        const message = data || {};
        if ((0, exports.typeMatches)(pattern)(message.type)) {
            handler(message);
        }
    };
    window.addEventListener('message', listener);
    listeners[listenerId] = listener;
    return listenerId;
};
exports.subscribe = subscribe;
const unsubscribe = (listenerId) => window.removeEventListener('message', listeners[listenerId]);
exports.unsubscribe = unsubscribe;
//# sourceMappingURL=subscriptions.js.map